<template>
    <button v-if="inIframe" class="sidebar-button" @click="handleClick">
        <i class="material-icons">menu</i>
    </button>
</template>

<script>
export default {
    props: {
        dashboardUrl: {
            type: String,
            required: true,
        },
    },
    computed: {
        inIframe() {
            return window !== window.parent;
        },
    },
    methods: {
        handleClick() {
            if (this.inIframe) {
                window.parent.postMessage(
                    {
                        event_id: "sidebar_toggle",
                    },
                    this.dashboardUrl
                );
            }
        },
    },
};
</script>

<style scoped lang="scss"></style>
